import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ICenterCommissionDataTableRowFormMeta {
  debitCredit: FormInputMeta,
  rate: FormInputMeta,
  static: FormInputMeta,
  minimum: FormInputMeta,
  maximum: FormInputMeta,
    
    schema: any,
}

const CenterCommissionDataTableRowFormMeta = {} as ICenterCommissionDataTableRowFormMeta;

CenterCommissionDataTableRowFormMeta.debitCredit = {
  name: "debitCredit",
  label: "D/C",
  type: "select",
  options:  [
    {
      label: 'Debit',
      value: '1'
    },
    {
      label: 'Credit',
      value: '2',
    },
  ],
  validation: yup.string().required(),
},  
CenterCommissionDataTableRowFormMeta.rate = {
  name: "rate",
  label: "Taux",
  type: "number",
  validation: yup.string().required(),
}
CenterCommissionDataTableRowFormMeta.static = {
  name: "static",
  label: "Fixe",
  type: "text",
  validation: yup.string().required(),
}
CenterCommissionDataTableRowFormMeta.minimum = {
  name: "minimum",
  label: "Minimum",
  type: "number",
  validation: yup.string().required(),
}
CenterCommissionDataTableRowFormMeta.maximum = {
  name: "maximum",
  label: "Maximum",
  type: "number",
  validation: yup.string().required(),
}

CenterCommissionDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(CenterCommissionDataTableRowFormMeta));

export default CenterCommissionDataTableRowFormMeta;